<template>
  <v-sheet
    :height="height"
    :width="width"
    :color="mode === 'toolbar' ? cColor : iColor"
    class="wrapper"
  >
    <v-sheet
      v-ripple="!disabled"
      :color="cColor"
      :height="height - 2"
      :width="width - 1"
      :class="tagClass"
      @click="click()"
    >
      <template v-if="prepend !== ''">
        <v-icon
          :color="mode === 'toolbar' ? iColor : cColor"
        >
          {{ prepend }}
        </v-icon>
      </template>
      <template v-if="loading">
        <div
          :class="loadingClass"
          :style="`width: ${width}`"
        >
          <v-progress-circular
            indeterminate
            :size="loadingSize"
          />
        </div>
      </template>
      <template v-else>
        <div
          :class="defaultSlotClass"
          :style="`width: ${width}`"
        >
          <slot></slot>
        </div>
      </template>
    </v-sheet>
  </v-sheet>
</template>

<script>
export default {
  name: 'cButton',
  props: {
    mode: {
      type: String,
      default: 'common'
    },
    color: {
      type: String,
      default: 'normal'
    },
    prepend: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '35'
    },
    width: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loadingSize: {
      type: Number,
      default: 24
    }
  },
  computed: {
    tagClass () {
      return 'd-flex justify-center cursor px-2'
    },
    loadingClass () {
      let res = 'd-flex align-center justify-center white--text'
      if (this.mode === 'common') {
        res += '' 
      }
      return res
    },
    defaultSlotClass () {
      let res = 'd-flex align-center justify-center font-weight-light body-2 default-class'
      if (this.mode === 'common') {
        res = `${res} font-weight-light white--text`
      }
      if (this.mode === 'outlined') {
        res = `${res} font-weight-light ${this.iColor}--text`
      }
      if (this.mode === 'toolbar') {
        res = `${res} font-weight-medium ${this.iColor}--text`
      }
      return res
    },
    cColor () {
      let res = this.iColor
      if (this.mode === 'common') {
        res = ` ${this.iColor}`
      }
      if (this.mode === 'outlined') {
        res = ' white'
      }
      if (this.mode === 'toolbar') {
        res = `${this.iColor} lighten-5`
      }
      return res
    },
    iColor () {
      let res = (this.disabled)
        ? 'grey'
        : this.color
      return res
    },
    cHeight () { return (+this.height - 2) + 'px' }
  },
  methods: {
    click () {
      if (!this.loading && !this.disabled) {
        this.$emit('click')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .cursor {
    cursor: pointer;
  }
  .wrapper {
    padding: 1px;
    border-radius: 4px;
    .v-sheet {
      border-radius: 3px;
    }
  }
  .report-btn {
    .default-class {
      padding-right: 0!important;
    }
  }
</style>